import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {EditClientAdAccountModal} from "./EditClientAdAccountModal";
import {FaIcon} from "../../FaIcon";

class EditClientAdAccountModalButtonClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.handleSuccessfulEdited = this.handleSuccessfulEdited.bind(this);
    }

    handleSuccessfulEdited(clientAdAccountId) {
        this.props.onClientAdAccountEdited();
    }

    render() {
        // El título del modal se traduce ACÁ y viaja como prop: el modal se abre por `ref`
        // (`toggle()`), así que envolverlo a él con el HOC de i18n dejaría el ref apuntando al
        // wrapper. A este botón no le toma `ref` nadie.
        const { t } = this.props;
        // El lápiz sigue diciendo «Configurar límite diario» (lo nombran las guías in-app y su test);
        // el modal ya tiene dos cosas, el límite y el cruce con GA4, y se titula «Configurar la cuenta».
        const title = t('edit_client_ad_account_modal.configure_daily_limit');
        return (
            <span>
                {/* `guideAnchor`: el resultado de `anchorAttr(...)` cuando una guía apunta a este lápiz. */}
                <button className="edit-button"
                        type="button"
                        aria-label={title}
                        title={title}
                        onClick={() => {
                    this.editClientAdAccountModal.toggle()
                }}
                        {...this.props.guideAnchor}><FaIcon iconName={"pencil-alt"}/></button>
                <EditClientAdAccountModal title={t('edit_client_ad_account_modal.title')}
                                          ref={instance => {this.editClientAdAccountModal = instance;}}
                                          afterSuccessfulEdited={this.handleSuccessfulEdited}
                                          clientAdAccount={this.props.clientAdAccount}
                                          clientId={this.props.clientId}
                                          clientName={this.props.clientName}

                />
            </span>
        );
    }
}

export const EditClientAdAccountModalButton = withTranslation()(EditClientAdAccountModalButtonClass);
export default EditClientAdAccountModalButton;
